import styled from '@emotion/styled';
import { Responsive } from '../../utils';

export const StyledContactCardPhoneNumber = styled.div<{}>`
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: none;
	}
`;
